import React from 'react'
import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core'

function GenderSelect({ gender, setGender }) {
  return (
    <FormControl variant="outlined" fullWidth>
      <InputLabel>Gender*</InputLabel>
      <Select
        id="gender"
        value={gender}
        onChange={e => setGender && setGender(e.target.value)}
        label="Gender*"
      >
        <MenuItem value={'F'}>Female</MenuItem>
        <MenuItem value={'M'}>Male</MenuItem>
        <MenuItem value={'O'}>Other</MenuItem>
      </Select>
    </FormControl>
  )
}

export default GenderSelect
